import { connectSocket, disconnectSocket } from './socket';

let started = false;
let socketRef = null;
let handlersRef = null;

export function startIssuesRealtime() {
  if (started) return;
  started = true;

  const socket = connectSocket();
  socketRef = socket;

  const notifyRefresh = () => {
    try {
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('issues:refresh'));
        window.dispatchEvent(new Event('badges:refresh'));
      }
    } catch {
      // ignore
    }
  };

  handlersRef = {
    created: notifyRefresh,
    updated: notifyRefresh,
    deleted: notifyRefresh,
    attachmentCreated: notifyRefresh,
    createdMine: notifyRefresh,
    updatedMine: notifyRefresh,
    deletedMine: notifyRefresh,
    attachmentCreatedMine: notifyRefresh,
  };

  socket.on('issue:created', handlersRef.created);
  socket.on('issue:updated', handlersRef.updated);
  socket.on('issue:deleted', handlersRef.deleted);
  socket.on('issue:attachment:created', handlersRef.attachmentCreated);

  socket.on('issue:created:mine', handlersRef.createdMine);
  socket.on('issue:updated:mine', handlersRef.updatedMine);
  socket.on('issue:deleted:mine', handlersRef.deletedMine);
  socket.on('issue:attachment:created:mine', handlersRef.attachmentCreatedMine);
}

export function stopIssuesRealtime() {
  if (!started) return;
  started = false;

  const socket = socketRef;
  const h = handlersRef;
  socketRef = null;
  handlersRef = null;

  if (socket && h) {
    try {
      socket.off('issue:created', h.created);
      socket.off('issue:updated', h.updated);
      socket.off('issue:deleted', h.deleted);
      socket.off('issue:attachment:created', h.attachmentCreated);

      socket.off('issue:created:mine', h.createdMine);
      socket.off('issue:updated:mine', h.updatedMine);
      socket.off('issue:deleted:mine', h.deletedMine);
      socket.off('issue:attachment:created:mine', h.attachmentCreatedMine);
    } catch {
      // ignore
    }
  }

  disconnectSocket();
}
